export const getCoordinatesId = (filePath: string, faceId: string) => filePath + faceId;
